import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import { client } from "../dtos/Client";
import * as Dtos from "../dtos/Tmd.dtos";
import { SearchPersonnelAdvanced } from "../dtos/Tmd.dtos";

export const personnelApi = {
    getPersonnel: (): Observable<Dtos.GetPersonnelResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnel = new Dtos.GetPersonnel();

        //Send request.
        const response: Promise<Dtos.GetPersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelById: (id: number): Observable<Dtos.GetPersonnelByIdResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelById = new Dtos.GetPersonnelById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetPersonnelByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setPersonnel: (personnel: Dtos.Personnel): Observable<Dtos.SetPersonnelResponse> => {
        
        let request: Dtos.SetPersonnel = new Dtos.SetPersonnel();

        request.personnel = personnel;

        // send request
        const response: Promise<Dtos.SetPersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    validatePersonnel: (personnel: Dtos.Personnel): Observable<Dtos.ValidatePersonnelResponse> => {
        
        let request: Dtos.ValidatePersonnel = new Dtos.ValidatePersonnel();

        request.personnel = personnel;

        // send request
        const response: Promise<Dtos.ValidatePersonnelResponse> = client.post(request);

        return Observable.from(response);

    },
    createPersonnel: (): Observable<Dtos.CreatePersonnelResponse> => {
        //Create the request.
        let request: Dtos.CreatePersonnel = new Dtos.CreatePersonnel();

        //Send request.
        const response: Promise<Dtos.CreatePersonnelResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    resendEmail: (id: number): Observable<Dtos.PostPersonnelResendEmailResponse> => {

        let request: Dtos.PostPersonnelResendEmail = new Dtos.PostPersonnelResendEmail();

        request.id = id;

        // send request
        const response: Promise<Dtos.PostPersonnelResendEmailResponse> = client.post(request);

        return Observable.from(response);
    },
    getPersonnelPermissionsById: (id: number): Observable<Dtos.GetPersonnelPermissionsByIdResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelPermissionsById = new Dtos.GetPersonnelPermissionsById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetPersonnelPermissionsByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelByRole: (): Observable<Dtos.GetPersonnelByRoleResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelByRole = new Dtos.GetPersonnelByRole();

        //Send request.
        const response: Promise<Dtos.GetPersonnelByRoleResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    searchPersonnelAdvanced: (searchPersonnelAdvanced: SearchPersonnelAdvanced): Observable<Dtos.GetPersonnelAdvancedSearchResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelAdvancedSearch = new Dtos.GetPersonnelAdvancedSearch();
        request.searchPersonnelAdvanced = searchPersonnelAdvanced;

        //Send request.
        const response: Promise<Dtos.GetPersonnelAdvancedSearchResponse> = client.post(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelTmdRole: (): Observable<Dtos.GetPersonnelTmdRoleResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelTmdRole = new Dtos.GetPersonnelTmdRole();

        //Send request.
        const response: Promise<Dtos.GetPersonnelTmdRoleResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelCategory: (): Observable<Dtos.GetPersonnelCategoryResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelCategory = new Dtos.GetPersonnelCategory();

        //Send request.
        const response: Promise<Dtos.GetPersonnelCategoryResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelTmdTrial: (): Observable<Dtos.GetPersonnelTmdTrialResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelTmdTrial = new Dtos.GetPersonnelTmdTrial();

        //Send request.
        const response: Promise<Dtos.GetPersonnelTmdTrialResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelTrialGroup: (): Observable<Dtos.GetPersonnelTrialGroupResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelTrialGroup = new Dtos.GetPersonnelTrialGroup();

        //Send request.
        const response: Promise<Dtos.GetPersonnelTrialGroupResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
}